/**
 * FinanceCapabilityState — FM1 Canonical Truthful State Component
 *
 * FM1 FROZEN backward-compatible wrapper.
 * Delegates to the shared CapabilityState platform primitive (UX1A).
 *
 * Frozen interface contract (DO NOT CHANGE):
 *   state ∈ { COMING_SOON | NOT_CONFIGURED | UNMAPPED | NOT_AVAILABLE | BLOCKED }
 *   props: state, title, reason, compact, data-testid
 *
 * testid compatibility: still emits `finance-capability-*` for FM1 audit tests.
 */
import React from "react";
import { CapabilityState } from "../shared/CapabilityState";

export function FinanceCapabilityState({
  state = "COMING_SOON",
  title,
  reason,
  compact = false,
  "data-testid": testId,
}) {
  // Preserve FM1-A frozen testid contract: finance-capability-{state}
  const resolvedTestId =
    testId || `finance-capability-${state.toLowerCase()}`;

  return (
    <CapabilityState
      state={state}
      title={title}
      reason={reason}
      compact={compact}
      data-testid={resolvedTestId}
    />
  );
}
